<template>
    <b-container>
        <Loading :active.sync="Loading"></Loading>
        <h2>Guillotina</h2>
        <div  v-if="!isMobile()" >
        <b-col lg="12"  class="my-1">    
            <div class="flex  mt-3 mb-0 ml-5">
  			    <select class="form-control" v-model="selected"  style="width:auto;">
				    <option v-for="campo in campos">{{ campo }}</option>
				</select>
				<input type="text" placeholder="Buscar" class="form-control " v-model="valor"  @keyup.enter="buscar">
                <b-button v-if="sw" class="buscar"  :disabled="!selected" @click="buscar">Buscar</b-button>
                <b-button v-else class="buscar"  :disabled="!selected" @click="limpiar">Limpiar</b-button>
                <b-form-group
                  label="Por página"
                  label-cols-sm="6"
                  label-cols-md="6"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="perPageSelect"
                  class="ml-5"
            >
                <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                ></b-form-select>
            </b-form-group>
			</div>	
            
        </b-col>
       
        <vtable :items="datosphp" :fields="fields"  :currentPage="currentPage" :perPage="perPage" :sortBy="sortBy" :sortDesc="sortDesc" />
        <b-pagination
                  v-model="currentPage"
                  :total-rows="datosphp.length"
                  :per-page="perPage"
                  align="center" 
                  
                  class="my-0"
                >
        </b-pagination>
        </div>
        <div v-else >
             
            <div class="flex">
  			    <select class="form-control" v-model="selected"  style="width:auto;">
				    <option v-for="campo in campos">{{ campo }}</option>
				</select>
				<input type="text" placeholder="Buscar" class="form-control " v-model="valor"  @keyup.enter="buscar">
                <b-button class="buscar"  :disabled="!selected" @click="buscar">Buscar</b-button>
                <b-form-group
                  label="Por página"
                  label-size="sm"
                  label-for="perPageSelect"
                  
            >
                <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                ></b-form-select>
            </b-form-group>
			</div>	
            
       <vtable :items="datosphp" :fields="fields"  :currentPage="currentPage" :perPage="perPage" :sortBy="sortBy" :sortDesc="sortDesc" />
            <b-pagination
                      v-model="currentPage"
                      :total-rows="datosphp.length"
                      :per-page="perPage"
                      align="center" 

                      class="my-0"
                    >
            </b-pagination>
        </div>
    </b-container>   
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    import vtable from '@/components/bitacoras/vtable'
    export default {
        name:'listado',
        mixins : [customMixin],
        components:{
            Loading, vtable
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 50, 100],
                sortBy: 'Id',
                sortDesc: true,
                limit:500,
                valor:'',
                filterOn: [],
                totalRows: 1,
                campos:['Orden','Operario','Producto'],
                selected:'',
                fields:[
                    {key:'Id',label:'Id',sortable:true},
                    {key:'DiaHora',label:'Dia Hora',sortable:true},
                    {key:'Orden',label:'Orden',sortable:true},
                    {key:'Contador',label:'Contador',sortable:true},
                    {key:'Operario',label:'Operario',sortable:true},
                    {key:'Estatus',label:'Estatus',sortable:false},
                    {key:'Producto',label:'Producto',sortable:true},
                ],
                sw: true,
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('guillotina',['datosphp']),
            ...mapState(['windowWidth']),//llamamos al estado.
            
        },
        
        methods:{
            ...mapActions({
                _fetchDatos: 'guillotina/fetchDatos',
                _fetchAll: 'guillotina/fetchAll',
                _buscar: 'guillotina/buscarPorCampo',
            }),
            ...mapMutations({
                _setNull: 'guillotina/setDatosNull'
            }),
            init(){
                let payload
                payload = {
                    'limit': this.limit,
                    
                }
                this._fetchAll()
               
            },
            buscar(){
                let payload
                payload = {
                    'limit' : this.limit,
                    'campo' : this.selected,
                    'valor' : this.valor
                }
                this._buscar(payload).then(() =>{
                     if(this.datosphp == false){
                         this.sw = false
                     }
                })
            },
            limpiar(){
                this.$router.go(0)
            },
        }
        
    }
</script>

<style lang="scss" scoped>
.form-control{
	width:300px; 
	height:36px;
}
.buscar{
    height:36px;
}
.flex {
    display: flex
}
@media (max-width: 767.98px) { 
      .flex{
          flex-direction:column;
      }
      .form-control{
        width:auto; 
	}
}
</style>